import { render, staticRenderFns } from "./ioRecordList.vue?vue&type=template&id=6860ac63&scoped=true"
import script from "./ioRecordList.vue?vue&type=script&lang=js"
export * from "./ioRecordList.vue?vue&type=script&lang=js"
import style0 from "./ioRecordList.vue?vue&type=style&index=0&id=6860ac63&prod&scoped=true&lang=css"
import style1 from "./ioRecordList.vue?vue&type=style&index=1&id=6860ac63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6860ac63",
  null
  
)

export default component.exports